import { makeStyles } from '@material-ui/core'
import moment from 'moment/moment'
import React from 'react'
import { FormattedMessage } from 'react-intl'
import { CONNECTED_SINCE } from '../constants/lawyer'

const useStyle = makeStyles({
  connectedShip: ({ iconSize }) => ({
    width: iconSize,
    height: iconSize,
    borderRadius: '50%',
  }),
  text: {
    marginLeft: 12,
    fontSize: 15,
  },
})

const ChipConnected = ({
  available = true,
  dateUpdated,
  className,
  hideText = false,
  iconSize = 12,
}) => {
  const classes = useStyle({ iconSize })

  const timeSinceConnected = moment.duration(moment().diff(moment(dateUpdated))).asMinutes()

  const getBackgroundColor = () => {
    if (timeSinceConnected <= CONNECTED_SINCE.palier1 && available) return '#43BC23'
    if (timeSinceConnected <= CONNECTED_SINCE.palier2 && available) return '#ffd971'
    if (timeSinceConnected <= CONNECTED_SINCE.palier3 && available) return '#ff7200'
    if (timeSinceConnected >= CONNECTED_SINCE.palier3 || !available) return '#ff0000'
  }

  const getBorderColor = () => {
    if (timeSinceConnected <= CONNECTED_SINCE.palier1 && available) return '#2E7E19'
    if (timeSinceConnected <= CONNECTED_SINCE.palier2 && available) return '#bb9f58'
    if (timeSinceConnected <= CONNECTED_SINCE.palier3 && available) return '#b64b00'
    if (timeSinceConnected >= CONNECTED_SINCE.palier3 || !available) return '#b90000'
  }

  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
      }}
      className={className}
    >
      <div
        className={classes.connectedShip}
        style={{
          background: getBackgroundColor(),
          borderWidth: 1,
          borderStyle: 'solid',
          borderColor: getBorderColor(),
        }}
      />
      {!hideText && (
        <span className={classes.text}>
          <FormattedMessage
            id={'ProfileLawyerShort.ConnectedSince'}
            defaultMessage={'En ligne depuis <b>{time}</b>'}
            values={{
              br: <br />,
              b: (...chunks) => <b>{chunks}</b>,
              time: moment.duration(moment(dateUpdated).diff(moment())).humanize(),
            }}
          />
        </span>
      )}
    </div>
  )
}

export default ChipConnected
